import React, { Component } from 'react';
import {
  Edit,
  TextInput,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
  ReferenceManyField,
  Datagrid,
  TextField,
  EditButton,
  EmailField,
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import PictureNote from 'components/PictureNote';
import ImageGridField from 'components/ImageGridField';
import FullNameField from 'components/FullNameField';
import UploadToolbar from 'components/UploadToolbar';
import Logo from './Logo';
import EditActions from './EditActions';

import Title from './Title';

class EditForm extends Component {
  state = {
    permissions: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.permissions !== state.permissions) {
      return {
        permissions: props.permissions,
      };
    }

    return null;
  }

  validateMobile = values => {
    const errors = {};
    if (values.mobile && !values.mobile.startsWith('+')) {
      errors.mobile = ['Mobile should start with +'];
    }
    return errors;
  };

  gotPermission = (permissions, model) => {
    if (permissions !== null) {
      // console.log(permissions.hasOwnProperty(model));
      if (permissions.hasOwnProperty(model)) {
        return true;
      }
    }
    return false;
  };

  checkBrandRenault = car_brand_id => {
    if (car_brand_id === '8') {
      return true;
    }
    return false;
  };

  render() {
    const { ...props } = this.props;
    const { permissions } = this.state;

    return (
      <Edit
        title={<Title />}
        actions={<EditActions permissions={permissions} gotPermission={this.gotPermission} />}
        {...props}
      >
        <TabbedForm toolbar={<UploadToolbar showDelete={false} source={['logo_url']} />} validate={this.validateMobile}>
          {this.gotPermission(permissions, 'brands') && (
            <FormTab label="Information">
              <TextInput source="name" />
              <TextInput source="email" type="email" />
              <TextInput source="mobile" />
              <TextInput source="default_user_sol" label="Account" />
              <TextInput source="default_password_sol" type="password" label="Password" />
              <TextInput source="community_id" label="Community ID" />
              <TextInput
                source="rooftop_id"
                label={this.checkBrandRenault(props.id) ? 'Rooftop ID (Leng Kee Road)' : 'Rooftop ID'}
              />
              {this.checkBrandRenault(props.id) && (
                <TextInput source="rooftop_id2" label="Rooftop ID (Jalan Pesawat)" />
              )}
              <TextInput source="partner_id" label="Partner ID" />
              <TextInput source="partner_key" label="Partner Key" />
              <TextInput source="partner_version" label="Partner Version" />
              <Logo />
              <ImageInput source="qlogo_url" label="New Logo" accept="image/jpeg,image/png">
                <ImageField source="src" title="title" />
              </ImageInput>
              <PictureNote width="200" height="200" />
              <RichTextInput source="description" />
            </FormTab>
          )}
          {this.gotPermission(permissions, 'models') && (
            <FormTab label="Models">
              <ReferenceManyField
                addLabel={false}
                sort={{ field: 'name' }}
                reference="models"
                target="car_brand_id"
                perPage={-1}
                allowEmpty={true}
              >
                <Datagrid>
                  <ImageGridField source="img_url" title="title" label="Images" />
                  <TextField source="name" />
                  <EditButton />
                </Datagrid>
              </ReferenceManyField>
            </FormTab>
          )}
          {this.gotPermission(permissions, 'contactinfos') && (
            <FormTab label="Contact Infos">
              <ReferenceManyField
                addLabel={false}
                sort={{ field: 'name' }}
                reference="contactinfos"
                target="car_brand_id"
                perPage={-1}
                allowEmpty={true}
              >
                <Datagrid>
                  <TextField source="name" />
                  <TextField source="mobile" />
                  <TextField source="email" />
                  <EditButton />
                </Datagrid>
              </ReferenceManyField>
            </FormTab>
          )}
          {this.gotPermission(permissions, 'sales_advisors') && (
            <FormTab label="Sales Consultant">
              <ReferenceManyField
                addLabel={false}
                sort={{ field: 'full_name' }}
                reference="sales_advisors"
                target="car_brand_id"
                perPage={-1}
              >
                <Datagrid>
                  <FullNameField />
                  <EmailField source="email" />
                  <TextField source="mobile" />
                  <EditButton />
                </Datagrid>
              </ReferenceManyField>
            </FormTab>
          )}
          {this.gotPermission(permissions, 'service_consultants') && (
            <FormTab label="Service Consultant">
              <ReferenceManyField
                addLabel={false}
                sort={{ field: 'full_name' }}
                reference="service_consultants"
                target="car_brand_id"
                perPage={-1}
              >
                <Datagrid>
                  <FullNameField />
                  <EmailField source="email" />
                  <TextField source="mobile" />
                  <EditButton />
                </Datagrid>
              </ReferenceManyField>
            </FormTab>
          )}
        </TabbedForm>
      </Edit>
    );
  }
}

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/CarBrand/EditForm.js